import { render, staticRenderFns } from "./BottomLink.vue?vue&type=template&id=f92936b6&scoped=true&"
import script from "./BottomLink.vue?vue&type=script&lang=js&"
export * from "./BottomLink.vue?vue&type=script&lang=js&"
import style0 from "./BottomLink.vue?vue&type=style&index=0&id=f92936b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92936b6",
  null
  
)

export default component.exports